/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Timeline_Zoom_OutInputs */

const en_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom out on the Timeline`)
};

const fr_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezoomer sur la timeline`)
};

const de_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitleiste herauszoomen`)
};

const it_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riduci lo zoom sulla linea temporale`)
};

const ru_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отдалите масштаб временной шкалы.`)
};

const es_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alejar la línea de tiempo`)
};

const zh_cn2_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩小时间线`)
};

const ja_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムラインをズームアウトする`)
};

const hi_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन पर ज़ूम आउट करें`)
};

const pt_pt2_shortcut_keys_desc_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminua o zoom na Linha do Tempo`)
};

/**
* | output |
* | --- |
* | "Zoom out on the Timeline" |
*
* @param {Shortcut_Keys_Desc_Timeline_Zoom_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_timeline_zoom_out = /** @type {((inputs?: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Timeline_Zoom_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_timeline_zoom_out(inputs)
	if (locale === "de") return de_shortcut_keys_desc_timeline_zoom_out(inputs)
	if (locale === "it") return it_shortcut_keys_desc_timeline_zoom_out(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_timeline_zoom_out(inputs)
	if (locale === "es") return es_shortcut_keys_desc_timeline_zoom_out(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_timeline_zoom_out(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_timeline_zoom_out(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_timeline_zoom_out(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_timeline_zoom_out(inputs)
	return en_shortcut_keys_desc_timeline_zoom_out(inputs)
});